export default "images/favicon.ico";